import { render, staticRenderFns } from "./myMessageSet.vue?vue&type=template&id=8f58079e&scoped=true"
import script from "./myMessageSet.vue?vue&type=script&lang=ts"
export * from "./myMessageSet.vue?vue&type=script&lang=ts"
import style0 from "./myMessageSet.vue?vue&type=style&index=0&id=8f58079e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f58079e",
  null
  
)

export default component.exports